const svg = (d: string) => `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${d}</svg>`;

export const icons = {
  /** Launcher: a speech bubble with a spark — "tell us" rather than "bug". */
  bug: svg('<path d="M21 11.5a8.4 8.4 0 01-8.5 8.3 8.9 8.9 0 01-3.6-.8L4 20l1.1-4.2A8.2 8.2 0 013.5 11.5 8.5 8.5 0 0112 3.2a8.5 8.5 0 019 8.3z"/><path d="M12 8.2v1.6M12 13.3v1.6M9.4 11.5H8M16 11.5h-1.4" stroke-width="2.2"/>'),
  chat: svg('<path d="M21 11.5a8.4 8.4 0 01-8.5 8.3 8.9 8.9 0 01-3.6-.8L4 20l1.1-4.2A8.2 8.2 0 013.5 11.5 8.5 8.5 0 0112 3.2a8.5 8.5 0 019 8.3z"/>'),
  close: svg('<path d="M18 6L6 18M6 6l12 12"/>'),
  back: svg('<path d="M15 18l-6-6 6-6"/>'),
  camera: svg('<path d="M23 19a2 2 0 01-2 2H3a2 2 0 01-2-2V8a2 2 0 012-2h4l2-3h6l2 3h4a2 2 0 012 2z"/><circle cx="12" cy="13" r="4"/>'),
  upload: svg('<path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M17 8l-5-5-5 5M12 3v12"/>'),
  send: svg('<path d="M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z"/>'),
  clock: svg('<circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/>'),
  check: svg('<path d="M20 6L9 17l-5-5"/>'),
  ask: svg('<circle cx="12" cy="12" r="9"/><path d="M9.5 9.3a2.6 2.6 0 015 .9c0 1.7-2.5 2.2-2.5 3.8M12 17h.01"/>'),
  pen: svg('<path d="M12 20h9M16.5 3.5a2.1 2.1 0 013 3L7 19l-4 1 1-4L16.5 3.5z"/>'),
  reply: svg('<path d="M9 17l-5-5 5-5M4 12h11a5 5 0 015 5v2"/>'),
  plus: svg('<path d="M12 5v14M5 12h14"/>'),
  clip: svg('<path d="M21.4 11.05l-9.2 9.2a6 6 0 01-8.5-8.5l9.2-9.2a4 4 0 015.7 5.7l-9.2 9.2a2 2 0 01-2.8-2.8l8.5-8.5"/>'),
  search: svg('<circle cx="11" cy="11" r="7"/><path d="M21 21l-4.3-4.3"/>'),
  pin: svg('<path d="M9 4h6l-1 6 3.5 3H6.5L10 10 9 4z"/><path d="M12 13v7"/>'),
  /** Screen recording: a filled dot in a ring. */
  rec: svg('<circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="4" fill="currentColor"/>'),
  trash: svg('<path d="M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6"/>'),
};
